import {
  Box,
  Button,
  Center,
  CircularProgress,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent, ModalFooter, ModalHeader, ModalOverlay, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverHeader, PopoverTrigger, Table, Td, Tooltip, Tr, useDisclosure
} from '@chakra-ui/react';
import { FieldInputProps, useFormikContext } from 'formik';
import { memo, useEffect, useMemo, useState } from 'react';
import * as BiIcons from 'react-icons/bi';
import { FaPlus } from 'react-icons/fa';
import { IconType } from 'react-icons/lib';

export const DEFAULT_ICON = 'BiPen';

type IconTableProps = {
  name: string,
  onClose?: () => void
}

const IconTable = ({ name, onClose = () => { } }: IconTableProps) => {


  const GROUP_SIZE = 20;
  const {
    setFieldValue,
  } = useFormikContext();
  const onIconClick = (key: string) => () => {
    setFieldValue(name, key);
    onClose();
  }
  const iconGroups = Object.entries(BiIcons).reduce((collector, entry, index): [string, IconType][] => {

    if (index % GROUP_SIZE === 0) {
      collector.push([]);
      collector[collector.length - 1].push(entry);
    } else {
      collector[collector.length - 1].push(entry);
    }
    return collector;

  }, []);

  const toHumanFriendlyIconDescription = (key: string): string => {
    const output = key.replace(/^Bi/, '').replace(/([a-z])([A-Z])/gu, '$1 $2');
    return output
  }

  return (
    <>
      {iconGroups.map((group, groupIndex) => (
        <Tr key={`group${groupIndex}`}>
          {group.map(([key, value], index) => {
            const Icon = BiIcons[key];
            return (
              <Td key={key} onClick={onIconClick(key)} _hover={{ cursor: 'pointer' }}>
                <Tooltip hasArrow label={toHumanFriendlyIconDescription(key)} placement='bottom'>
                  <Box width='14px'>
                    <Icon />
                  </Box>
                </Tooltip>
              </Td>
            );
          })}
        </Tr>
      ))
      }
    </>);
};

const IconTableMemo = memo(IconTable);


export default function IconSelectionControl({
  name,
  value,
  onChange = () => { },
  onBlur = () => { }
}: FieldInputProps<string>) {

  const [visible, setVisible] = useState(false);
  const [isProgressVisible, setProgressVisible] = useState(false);
  const Icon = BiIcons[value];

  const { isOpen, onOpen, onClose } = useDisclosure();
  const onIconSelectionOpen = () => {
    setProgressVisible(true);
    onOpen();
  }

  const onIconSelectionClose = () => {
    setProgressVisible(false);
    onClose();
  }


  return (
    <Box _hover={{ cursor: 'pointer' }} >
      <HStack>
        <Center>
          {Icon && <Icon key={value} onClick={onIconSelectionOpen} />}
          {isProgressVisible && <CircularProgress isIndeterminate color='app.primary' size='14px' />}
        </Center>
      </HStack>
      <Modal
        isOpen={isOpen}
        onClose={onIconSelectionClose}>
        <ModalOverlay />
        <ModalContent minW={1600} overflowY='scroll'>
          <ModalHeader>Choose Icon</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table>
              {/*TODO: Memoize properly, as it takes too long to render this component*/}
              <IconTableMemo name={name} onClose={onIconSelectionClose} />
            </Table>
          </ModalBody>
        </ModalContent>
      </Modal>

    </Box>
  )
}